/* Restart countdowns when a page is revisited, including browser back/forward cache. */
(function () {
  function resetTimers() {
    customElements.whenDefined('countdown-timer').then(function () {
      document.querySelectorAll('countdown-timer').forEach(function (timer) {
        var duration = Number(timer.duration);
        if (!Number.isFinite(duration) || duration <= 0) return;
        var running = timer.isPlaying || timer.dataset.autoPlay === 'true';
        clearInterval(timer.playInterval);
        timer.isPlaying = false;
        timer.dataset.duration = String(duration);
        timer.updateTimer();
        if (running) timer.playTimer();
      });
    });
  }
  window.addEventListener('pageshow', resetTimers);
  window.addEventListener('popstate', resetTimers);
})();
